<template>
  <div class="page-container md-layout-column">

    <md-dialog-alert
      :md-active.sync="error.show"
      :md-title="error.title"
      :md-content="errorMessage(error.error)"
      md-confirm-text="Ok"/>

    <md-field v-if="deliveryCostPayAnyway" class="md-invalid">
      <md-icon class="md-accent">warning</md-icon>
      <md-input disabled value="Взять деньги за доставку при отказе" style="color: red; -webkit-text-fill-color: red"/>
    </md-field>

    <md-content>
      <md-field :class="messageClass">
        <md-icon>input</md-icon>
        <label for="denied_type">Тип отказа</label>
        <md-select @md-selected="calcClientPrice" v-model="statusOptions.deny_type" name="denied_type" id="denied_type"
                   required>
          <md-option value="CALL">Отказ при прозвоне</md-option>
          <md-option value="PLACE">Отказ на месте</md-option>
        </md-select>
      </md-field>

      <md-field :class="messageClass">
        <md-icon>input</md-icon>
        <label for="cause_denied_type">Причина отказа</label>
        <md-select v-model="statusOptions.deny_reason_id" name="cause_denied_type" id="cause_denied_type" required>
          <md-option value="3">Передумал приобретать</md-option>
          <md-option value="8">Размер не соответствует заявленному</md-option>
          <md-option value="27">Отказ без объяснения причины</md-option>
          <md-option value="21">Не может получить заказ (отсутствует в городе/в больнице)</md-option>
          <md-option value="19">Не корректный адрес/вне зоны обслуживания</md-option>
          <md-option value="10">Не устраивает качество</md-option>
          <md-option value="2">Нет денег в наличии</md-option>
          <md-option value="22">Запрещен частичный выкуп</md-option>
          <md-option value="20">Запрещено вскрытие</md-option>
          <md-option value="18">Брак/несоотвествие вложения</md-option>
          <md-option value="5">Не заказывали</md-option>
          <md-option value="1">Нарушен срок доставки или интервал</md-option>
        </md-select>
      </md-field>

      <md-field>
        <label>Стоимость доставки для покупателя: </label>
        <md-input :value="order.order.DeliveryCost" readonly/>
      </md-field>

      <md-field>
        <md-icon v-if="statusOptions.deny_type==='PLACE'">input</md-icon>
        <label>Фактически принято с покупателя за доставку: </label>
        <md-input v-if="statusOptions.deny_type==='PLACE'" type="number" v-model="order.clientPaid"/>
        <md-input v-else value="0"/>
      </md-field>

      <md-field>
        <label>Фактическая дата доставки: </label>
        <md-input :value="currentDate" readonly/>
      </md-field>

      <md-field>
        <label>Получить с покупателя: </label>
        <md-input :value="order.clientFullPrice" readonly/>
      </md-field>

      <md-field>
        <label>Получено с покупателя: </label>
        <md-input v-model="order.clientPaid" readonly/>
      </md-field>

      <md-field>
        <label>Комментарий: </label>
        <md-textarea v-model="statusOptions.comment"/>
      </md-field>

      <md-dialog-confirm
        :md-active.sync="showSetStatusDialog"
        md-title="Установить статус?"
        :md-content="dialogMsg"
        md-confirm-text="Установить"
        md-cancel-text="Отмена"
        @md-cancel="onCancel"
        @md-confirm="setStatus"/>
      <md-button class="md-raised md-accent" @click="createDialog">Установить статус</md-button>
    </md-content>
  </div>
</template>
// на месте взятие денег деливери кост
<script>
  export default {
    name: "InWork",
    props: ['order'],
    data() {
      return {
        showSetStatusDialog: false,
        dialogMsg: '',
        lightInputs: false,
        statusOptions: {
          deny_type: '',
          deny_reason_id: '',
          date_fact_delivery: '',
          comment: '',
        },
      }
    },
    created: function () {
      this.statusOptions.date_fact_delivery = new Date();
    },
    methods: {
      calcClientPrice() {
        if (this.statusOptions.deny_type !== 'PLACE') {
          this.$props.order.clientPaid = 0;
        }
      },
      errorMessage(error) {
        return this.$store.getters.getErrorMessage(error)
      },
      setStatus() {
        this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
          event: "setOrderDeniedStatus",
          id: this.$props.order.order.Id,
          deny_type: this.statusOptions.deny_type,
          deny_reason_id: this.statusOptions.deny_reason_id,
          date_fact_delivery: this.statusOptions.date_fact_delivery,
          client_paid: Number(this.$props.order.clientPaid),
          comment: this.statusOptions.comment,
        }));
      },
      onCancel() {
        this.showSetStatusDialog = false
      },
      createDialog() {
        this.dialogMsg = `Установить заказу № ${this.$props.order.order.Id} финальный статус "Отказ?"`;
        this.showSetStatusDialog = true
      }
    },
    computed: {
      deliveryCostPayAnyway() {
        if (this.$props.order.order.deliveryCostPayAnyway) return true;

        // todo костыль для купи випа
        let kupiIds = [1708, 1921, 1787, 1839, 1820, 1761, 1924];
        return kupiIds.includes(Number(this.$props.order.order.WebshopId));
      },
      currentDate: function () {
        const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
        return this.statusOptions.date_fact_delivery.toLocaleDateString(undefined, options)
      },
      error() {
        let err = this.$store.getters.getErrorByMethod('setStatus');
        if (err.show) this.lightInputs = true;
        return err
      },
      messageClass() {
        return {
          'md-invalid': this.lightInputs
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Status/Denied.vue